module.exports = __webpack_public_path__ + "static/media/product4.7f97f36c.png";